<form [formGroup]="inputFormArray" *ngIf="inputFormArray" #ngForm="ngForm">
  <div
    class="documents form-element"
    *ngFor="let item of inputFormArray.controls; let itemIndex = index; first as isFirst; last as isLast"
    [formGroupName]="itemIndex">
    <div>
      <div *ngIf="!isFirst" fxLayout="row" fxFlexAlign="stretch" style="margin-top: 16px">
        <h2>Abweichender Anschlussnutzer</h2>
      </div>
    </div>

    <!-- Section: Anschrift -->
    <section>
      <div *ngIf="selectedGisData && !id && isFirst">
        <button
          [matTooltip]="
            'Übernehmen Sie die Adresse aus dem Anlagenstandort (Ort, Postleitzahl, Straße und Hausnummer sofern vorhanden)'
          "
          mat-stroked-button
          color="primary"
          (click)="copyAddress()"
          style="margin: 1em 0">
          <mat-icon style="margin-right: 0.25em">content_copy</mat-icon>
          Objektanschrift übernehmen
        </button>
      </div>

      <h3>Anschrift</h3>

      <!-- Anrede -->
      <form-row>
        <mat-form-field appearance="outline">
          <mat-label>Anrede</mat-label>
          <mat-select formControlName="salutation">
            <mat-option *ngFor="let ele of metaService.salutationValues$ | async" [value]="ele.id">
              {{ ele.title }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="item.get('salutation').hasError('required')">Anrede ist erforderlich</mat-error>
        </mat-form-field>
      </form-row>
      <!-- Anrede -->

      <form-row>
        <!-- Vorname -->
        <mat-form-field *ngIf="item.get('salutation').value | isPerson | async" appearance="outline" fxFlex>
          <mat-label>Vorname</mat-label>
          <input matInput type="text" formControlName="firstName" appAdaptionSuppressAutocomplete />
          <mat-error>Vorname ist erforderlich</mat-error>
        </mat-form-field>
        <!-- Vorname -->
        <!-- Firmenname 1 -->
        <mat-form-field
          *ngIf="!(item.get('salutation').value | isPerson | async)"
          appearance="outline"
          fxFlex>
          <mat-label>Firmenname 1</mat-label>
          <input
            matInput
            type="text"
            formControlName="company"
            maxlength="40"
            appAdaptionSuppressAutocomplete />
          <mat-error>Firmenname 1 ist erforderlich</mat-error>
        </mat-form-field>
        <!-- Firmenname 1 -->

        <!-- Nachname -->
        <mat-form-field *ngIf="item.get('salutation').value | isPerson | async" appearance="outline" fxFlex>
          <mat-label>Nachname</mat-label>
          <input matInput type="text" formControlName="lastName" appAdaptionSuppressAutocomplete />
          <mat-error>Nachname ist erforderlich</mat-error>
        </mat-form-field>
        <!-- Nachname -->
        <!-- Firmenname 2 -->
        <mat-form-field
          *ngIf="!(item.get('salutation').value | isPerson | async)"
          appearance="outline"
          fxFlex>
          <mat-label>Firmenname 2</mat-label>
          <input matInput type="text" formControlName="companyAddition" appAdaptionSuppressAutocomplete />
        </mat-form-field>
        <!-- Firmenname 2 -->
      </form-row>

      <form-row>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Straße</mat-label>
          <input matInput type="text" formControlName="street" appAdaptionSuppressAutocomplete />
          <mat-error>Straße ist erforderlich</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Hausnummer</mat-label>
          <input
            matInput
            type="text"
            formControlName="streetNo"
            maxlength="6"
            appAdaptionSuppressAutocomplete />
          <mat-error>Hausnummer ist erforderlich</mat-error>
        </mat-form-field>
      </form-row>

      <form-row>
        <mat-form-field appearance="outline">
          <mat-label>PLZ</mat-label>
          <input matInput type="text" formControlName="zipCode" appAdaptionSuppressAutocomplete />
          <mat-error *ngIf="item.get('zipCode').hasError('required')">PLZ ist erforderlich</mat-error>
          <mat-error *ngIf="item.get('zipCode').hasError('maxlength')">
            PLZ darf maximal 10 Zeichen enthalten
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Ort</mat-label>
          <input matInput type="text" formControlName="city" appAdaptionSuppressAutocomplete />
          <mat-error>Ort ist erforderlich</mat-error>
        </mat-form-field>
      </form-row>
    </section>
    <!-- Section: Anschrift -->

    <!-- Section: Kontakt -->
    <section>
      <h3>Kontakt</h3>

      <!-- Telefon-->
      <form-row>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Telefon</mat-label>
          <input matInput type="text" formControlName="phone" appAdaptionSuppressAutocomplete />
          <mat-error>Telefonnummer ist erforderlich</mat-error>
        </mat-form-field>
      </form-row>
      <!-- Telefon-->

      <!-- E-Mail -->
      <form-row>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>E-Mail</mat-label>
          <input matInput type="email" formControlName="mail" appAdaptionSuppressAutocomplete />
          <mat-error *ngIf="!item.get('mail').valid && item.get('mail').touched">
            {{ validatorsService.getErrorMail(item, 'mail') }}
          </mat-error>
        </mat-form-field>
      </form-row>
      <!-- E-Mail -->
    </section>
    <!-- Section: Kontakt -->

    <!-- Abweichender Anschlussnutzer für Lieferung -->
    <form fxLayout="row" fxFlexAlign="stretch" *ngIf="!disableContractPartner && isFirst">
      <form-row>
        <mat-checkbox
          [disabled]="!canUpdate"
          (change)="onToggle($event)"
          [(ngModel)]="differentContractPartner"
          name="differentContratPartner">
          Abweichender Anschlussnutzer für Lieferung
        </mat-checkbox>
      </form-row>
    </form>
    <!-- Abweichender Anschlussnutzer für Lieferung -->
  </div>
</form>
